import { FormHelperText } from "@mui/material";
import { FormControl } from "./index";
import PropTypes from "prop-types";
import NumericInput from 'material-ui-numeric-input';

const TextBox = props => {

    const onInput = (event) => {
        const value = event.target.value
        if (value && value.toString().length <= 10) {
            props.onChange(Number(value))
        }
    }
    const {
        name,
        label,
        value,
        fullWidth,
        helperText,
        variant,
    } = props;

    return (
        <FormControl
            key={`key${name}`}
            error={helperText ? true : false}
            fullWidth={fullWidth}
        >

            <NumericInput
                name={name}
                precision={0}
                decimalChar='-'
                thousandChar='-'
                label={label}
                value={Number(value)}
                onChange={(event) => onInput(event)}
                variant={variant}
            />

            {helperText &&
                <FormHelperText>
                    {helperText}
                </FormHelperText>}
        </FormControl>
    );
};

TextBox.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    variant: PropTypes.string,
    onChange: PropTypes.func,
}

TextBox.defaultProps = {
    variant: "outlined",
    error: "",
    value: "",
    required: false,
    fullWidth: false,
    helperText: "",
    disabled: false,

}

export default TextBox;
